import { createStore } from "owa-satcheljs";
import type { DialogHostStore } from "../store/schema/DialogHostStore";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Required for performance due to JSX usage
import { makeObservable, observable } from "mobx";

export function createDialogHostStore(): DialogHostStore {
    const store: DialogHostStore = {
        dialogs: new Map(),
    };
    
    makeObservable(store, {
        dialogs: observable.shallow,
    });
    
    return store;
}

export const getStore: () => DialogHostStore = createStore<DialogHostStore>("DialogHostStore", 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function createDialogHostStore called at module scope is not allowed. This may cause unwanted side effects. */
createDialogHostStore());
